import $ from 'jquery';
import DateFilter from '@/components/date-filter';
import api_op from "@/api/comptabilite/_operations"
import api_patients from '@/api/clinique/_patients'

export default {
    name: 'facture-en-cours',
    components: {
        DateFilter
    },
    props: [],
    data() {
        return {
            current_date_filter: {},
            curr_month: "",          // Current month of the year
            filter_date: '',

            date_filters: [
                { slug: 'date', libelle: 'Date' },
                { slug: 'entre_deux_date', libelle: 'Entre deux dates' }
            ],
            filter_by_date: { slug: '', libelle: '' },
            is_loading: true,
            is_empty: false,
            is_load_error: false,

            fields: [
                'patient', { key: 'montant_du', label: 'Montant dû' }
            ],
            filter: "",
            perPage: 50,
            currentPage: 1,
            selected_patient: {
                patient_id: '',
                nom_patient: '',
                sexe: '',
                telephone_mobile: '',
                age: ''
            },
            operations_en_attente: [],
            operations_length: 0,
            is_month: false,
            liste_request_id: 0,
        }
    },

    watch: {
        filter_date() {
            if (this.filter_date != '') {
                this.filter_by_date = this.filter_date;
                
                if (this.filter_by_date.slug) {
                    $('.date-filter-cfactures').modal('show')
                }
            }
        },

        curr_month(month) {
            if (!month || !month.id) return
            const data = {
                month: month.id,
                one_date: "",
                from_date: "",
                to_date: "",
            }
            this.is_month = true
            this.current_date_filter = data
            this.getListeOperations(data)
        },
    },

    computed: {

    },

    mounted() {
        console.log("Load op en attente");
        
        this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", {});

        // Le tableau s'ouvre sur le mois courant ; le watcher effectue l'unique chargement.
        this.curr_month = this.monthOfYear[this.current_date.getMonth() + 1]
    },

    methods: {
        /**
         * Liste des opération en attente
         * @param {*} data 
         * @returns 
         */
        getOpertaionsEnAttente(data) {
            return new Promise((resolve, reject) => {
                api_op.getOpertaionsEnAttente(data).then(
                    (response) => {
                        resolve(response);
                    },
                    (error) => {
                        reject(error);
                    }
                );
            });
        },

        async getListeOperations(data) {
            const requestId = ++this.liste_request_id
            this.is_load_error = false
            this.is_loading = true
            try {
                const response = await this.getOpertaionsEnAttente(data)
                const lignes = Array.isArray(response) ? response : []
                const manquants = [...new Set(lignes.filter(ligne => {
                    const nom = String(ligne.info_patient && ligne.info_patient.patient || '').trim()
                    return ligne.patient_id && (!nom || /^Patient n[°o]\s*\d+$/i.test(nom))
                }).map(ligne => ligne.patient_id))]
                const identites = await Promise.all(manquants.map(async id => {
                    try {
                        const patient = await api_patients.getPatientName(id)
                        return [String(id), [patient && patient.nom, patient && patient.prenoms].filter(Boolean).join(' ').trim()]
                    } catch (_) { return [String(id), ''] }
                }))
                if (requestId !== this.liste_request_id) return
                const noms = identites.reduce((acc, entree) => { acc[entree[0]] = entree[1]; return acc }, {})
                this.operations_en_attente = lignes.map(ligne => noms[String(ligne.patient_id)]
                    ? { ...ligne, info_patient: { ...(ligne.info_patient || {}), patient: noms[String(ligne.patient_id)] } }
                    : ligne)
                this.operations_length = this.operations_en_attente.length
                if (this.operations_en_attente.length > 0) {
                    this.is_empty = false
                } else {
                    this.is_empty = true
                }
                this.is_loading = false
            } catch (_) {
                if (requestId !== this.liste_request_id) return
                this.is_load_error = true
                this.is_loading = false
            }
        },

        filterByDate(date) {
            const data = {
                month: "",
                one_date: date.single_date,
                from_date: date.from_date,
                to_date: date.to_date,
                from_hour: date.from_hour,
                to_hour: date.to_hour,
            }

            this.filter_date = ""
            this.curr_month = null
            this.is_month = false
            this.current_date_filter = data
            this.getListeOperations(data)
        },

        /**
         * Actualiser la facturation en cours
         */
        refreshFacture() {
            console.log("refresh op");
            
            this.getListeOperations(this.current_date_filter)
        },

        goToFactureAttente(info_patient, patient_id) {
            this.selected_patient = {
                patient_id: patient_id,
                nom_patient: info_patient.patient,
                nom: info_patient.patient,
                prenoms: "",
                sexe: info_patient.sexe,
                telephone_mobile: info_patient.telephone,
                age: info_patient.age,
                num_dossier: info_patient.num_dossier
            }
            this.$store.commit("SET_SELECTED_PATIENT_ATTENTE", this.selected_patient);

            this.$router.push({ path: '/factures/patients-operations' })
        },
    }
}
